import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly activeRequestsSubject = new BehaviorSubject<number>(0);
  private readonly isLoadingSubject = new BehaviorSubject<boolean>(false);

  readonly isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();

  show(): void {
    this.updateRequests(1);
  }

  hide(): void {
    this.updateRequests(-1);
  }

  reset(): void {
    this.activeRequestsSubject.next(0);
    this.isLoadingSubject.next(false);
  }

  private updateRequests(delta: number): void {
    const nextValue = Math.max(this.activeRequestsSubject.value + delta, 0);
    this.activeRequestsSubject.next(nextValue);
    this.isLoadingSubject.next(nextValue > 0);
  }
}